<template>
  <div id="app">
    <BasicLayout/>
  </div>
</template>

<style>
/* 确保html和body设置为黑色背景，并控制滚动行为 */
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  overflow-x: hidden; /* 防止横向滚动条 */
  box-sizing: border-box;
}

#app {
  text-align: center;
  min-height: 100vh;
  background-color: black;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 全局样式重置 */
* {
  box-sizing: inherit;
}
</style>
<script setup lang="ts">
import BasicLayout from "@/layouts/BasicLayout.vue";
</script>
